import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/Common";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UserCircle, KeyRound, Loader2 } from "lucide-react";

export default function Profilo() {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [loading, setLoading] = useState(false);

  const changePw = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password aggiornata con successo");
      setCurrent(""); setNext("");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  const isGoogle = user?.auth_provider === "google";

  return (
    <div className="space-y-6">
      <PageHeader title="Profilo Utente" subtitle="Gestisci i tuoi dati e la sicurezza dell'account" />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <Card className="p-6 rounded-xl border-slate-200 bg-white shadow-sm">
          <div className="flex flex-col items-center text-center">
            {user?.picture ? (
              <img src={user.picture} alt="" className="h-20 w-20 rounded-full object-cover ring-2 ring-primary/20" />
            ) : (
              <div className="h-20 w-20 rounded-full bg-primary/10 flex items-center justify-center"><UserCircle className="h-10 w-10 text-primary" /></div>
            )}
            <h3 className="mt-4 font-heading text-lg font-semibold text-slate-800">{user?.name}</h3>
            <p className="text-sm text-muted-foreground">{user?.email}</p>
            <span className="mt-3 inline-flex rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary capitalize">{user?.role}</span>
            <span className="mt-2 text-xs text-slate-400">{isGoogle ? "Accesso tramite Google" : "Accesso email/password"}</span>
          </div>
        </Card>

        <Card className="lg:col-span-2 p-6 rounded-xl border-slate-200 bg-white shadow-sm">
          <div className="flex items-center gap-2 mb-5">
            <KeyRound className="h-5 w-5 text-primary" />
            <h3 className="font-heading font-semibold text-slate-800">Cambia password</h3>
          </div>
          {isGoogle ? (
            <p className="text-sm text-muted-foreground">Il tuo account usa l'accesso Google. La password è gestita da Google.</p>
          ) : (
            <form onSubmit={changePw} className="space-y-4 max-w-md">
              <div>
                <Label>Password attuale</Label>
                <Input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="current-password-input" className="mt-1.5 h-11" />
              </div>
              <div>
                <Label>Nuova password</Label>
                <Input type="password" required minLength={6} value={next} onChange={(e) => setNext(e.target.value)} data-testid="new-password-input" className="mt-1.5 h-11" />
              </div>
              <Button type="submit" disabled={loading} data-testid="change-password-button" className="font-semibold">
                {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Aggiorna password
              </Button>
            </form>
          )}
        </Card>
      </div>
    </div>
  );
}
